import { Column, ColumnOption } from "@app/model/column.model";

export class ColumnManager {
  columns: Column[];
  readonly headers: string[] = [];
  readonly keys: string[] = [];

  /**
   * empty constructor
   * @param columns
   */
  constructor(columnsOptions: ColumnOption[]) {
    this.columns = columnsOptions.map(options => {
      this.headers.push(options.header)
      this.keys.push(options.key)
      return new Column(options);
    });
  }

  /**
   * fetches column info by key or header
   * returns null if not found
   * @param constraint key | header
   * @param isHeader is constraint header or not default is false
   * @returns column
   */
  column(constraint: string, isHeader = false) {
    for (let column of this.columns) {
      if (column.key === constraint || (isHeader && column.header === constraint)) {
        return column;
      }
    }
    return null;
  }

  /**
   * returns header by key
   * @param key key name
   * @returns header
   */
  header(key: string) {
    for (let column of this.columns) {
      if (column.key == key) {
        return column.header;
      }
    }
    return null;
  }

  /**
   * return keys by header
   * @param header header name
   * @returns key
   */
  key(header: string) {
    for (let column of this.columns) {
      if (column.header == header) {
        return column.key;
      }
    }
    return null;
  }
}
